import React, { useState } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        
        {/* Logo */}
        <Link to="/" className="hover:opacity-90 transition">
          <img
            src="/logo192.png"
            alt="KambiHome Logo"
            className="h-12 sm:h-14 md:h-14 w-auto object-contain drop-shadow-md"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6 text-gray-700 font-medium">
          <a href="/" className="hover:text-green-600 transition">Home</a>
          <a href="/products" className="hover:text-green-600 transition">Products</a>
          <a href="/about" className="hover:text-green-600 transition">About</a>
          <a href="/contact" className="hover:text-green-600 transition">Contact</a>
        </nav>

        {/* Mobile Menu Icon */}
        <button
          onClick={toggleMenu}
          className="md:hidden p-2 text-gray-700 hover:text-green-600"
          aria-label="Toggle menu"
        >
          {isOpen ? <XMarkIcon className="w-6 h-6" /> : <Bars3Icon className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu Panel */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-md px-4 py-6">
          <nav className="flex flex-col space-y-4 text-gray-700 font-medium">
            <a href="/" onClick={toggleMenu} className="hover:text-green-600">Home</a>
            <Link to="/products" onClick={toggleMenu} className="hover:text-green-600">Products</Link>
            <Link to="/about" onClick={toggleMenu} className="hover:text-green-600">About</Link>
            <Link to="/contact" onClick={toggleMenu} className="hover:text-green-600">Contact</Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
